import { env } from '@/shared/lib/env'

/**
 * Shared user-activity tracking for the idle auto-logout.
 * The timestamp is mirrored to localStorage so activity in one tab
 * keeps sessions in other tabs of the same browser alive.
 */
const STORAGE_KEY = 'app:last-activity'

export const IDLE_TIMEOUT_MS = env.VITE_IDLE_TIMEOUT_MINUTES * 60_000

let lastActivity = Date.now()

export const recordActivity = (): void => {
    lastActivity = Date.now()
    try {
        localStorage.setItem(STORAGE_KEY, String(lastActivity))
    } catch {
        // localStorage unavailable (e.g. privacy mode) — in-memory value still works
    }
}

export const getLastActivity = (): number => {
    try {
        const stored = Number(localStorage.getItem(STORAGE_KEY))
        if (Number.isFinite(stored) && stored > lastActivity) {
            lastActivity = stored
        }
    } catch {
        // ignore
    }
    return lastActivity
}

export const isIdle = (): boolean => Date.now() - getLastActivity() >= IDLE_TIMEOUT_MS
